<template>
  <div v-if="checkReloadData && !showMarketingSite">
    <AlertArea v-if="alert" />
    <DarkOverlay ref="darkOverlay"/>
    <div :class="containerClass">
      <div v-if="showGlobalNav">
        <GlobalNav />
      </div>
      <router-view />
    </div>
    <DoGooderModal v-bind="modalProps" />
  </div>
  <div v-else>
    <MarketingSiteProxy/>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { router, timezoneMapping, railsTzToMomentTz, isMobile} from "../common";
import AlertArea from "../components/AlertArea";
import DarkOverlay from "../components/DarkOverlay.vue";
import DoGooderModal from "@/components/DoGooderModal"
import GlobalNav from "../components/GlobalNav"
import { userInfo } from "../common/user-info";
import moment from "moment-timezone";
import { eventBus } from "../main.js";
import MarketingSiteProxy from "@/components/MarketingSiteProxy.vue";
import { Capacitor } from "@capacitor/core";
import { App } from '@capacitor/app';

export default {
  name: "app",
 /* mixins: [
    ReloadMixin
  ],*/
  data() {
    return {
      bellNotifications: false,
      showGlobalNav: false,
    };
  },
  components: {
    AlertArea ,
    DarkOverlay,
    DoGooderModal,
    GlobalNav,
    MarketingSiteProxy
  },
  computed: {
    ...mapState({
      alert: state => state.alert
    }),
    ...mapState("user", ["modalProps", "status", "user", "usersById"]),
    ...mapState("rallies", ["allRalliesByRallyId", "moveRallies"]),
    ...mapState("rallies_v3", ["currentRally"]),
    checkIsMobile(){
      return isMobile()
    },
    containerClass() {
      // TODO: Refactor
      const routePath = this.$route?.path || ""
      const urls = [
        "createSpecialEvent",
        "createFundRaisers",
        "createQuickEvent",
        "createPayment",
        "createPoll",
        "createRally",
      ]
      const lastSegment = routePath.substring(routePath.lastIndexOf("/") + 1)
      const subClass = urls.includes(lastSegment) ? "sh-updated-container" : "sh-normal-container"

      return [
        subClass,
        {
          'members-route': this.$route.name === 'members',
          'signup-route': this.$route.name === 'CreateSignUp',
        },
      ]
    },
    alert() {
      return this.$store.getters['user/alert']?.message;
    },
    pageTitle: function() {
      if ( this.bellNotifications ) {
        return 'Notifications';
      }

      let rid = this.$route?.params?.rallyId ? this.$route.params.rallyId : ""
      let rallyTitle = rid && this.allRalliesByRallyId[rid] ?  this.allRalliesByRallyId[rid]?.rally?.attributes?.title : ""

      if ( rallyTitle && rallyTitle.length > 20 ) {
        rallyTitle = rallyTitle.slice(0, 20) + '...';
      }

      return rallyTitle || this.$route.meta.title;
    },
    async checkReloadData() {
      if (!this.showMarketingSite && !this.isExemptPage && (!userInfo() || !userInfo().user_id) ) {
        router.push({
          path: '/login',
          query: { ...this.$route.query }
        });
        return true
      }
      else if (!this.showMarketingSite && !this.isExemptPage && !this.usersById[parseInt(userInfo().user_id)]) {
        this.loadPageData();
        return false;
      } else if (!this.showMarketingSite && !this.isExemptPage) {
          if (railsTzToMomentTz(userInfo().timezone)){
            moment.tz.setDefault(railsTzToMomentTz(userInfo().timezone))
          }
      }
      return true;
    },
    isExemptPage() {
      const exemptPages = ["/login", "/resetpassword", "/resetpasswordemail", "/register", "/createAccount", "/igate"]

      return exemptPages.some(page => this.$route.path.includes(page))
    },
    showMarketingSite() { 
      console.log("showing marketing site")
      if ((Capacitor.getPlatform() == "android" || Capacitor.getPlatform() == "ios")){
        return false
      } else {
        return (this.$route.path === '/' || this.$route.path === '/home' || this.$route.path.includes('/home/')) && !userInfo();
      }
    },
  },
  watch: {
    $route(newRoute, _oldRoute) {
      this.ensureCurrentRally(newRoute)
    },
    "$route.path"() {
      this.updateShowGlobalNav();
    },
  },
  created(){
      console.log("App is bootstrapping...");
      const platformClass = Capacitor.getPlatform(); 
      document.body.classList.add(platformClass);
      eventBus.on('overlayOn' , (p) => {
        this.$refs.darkOverlay.overlayOn();
      })
      eventBus.on('overlayOff' , (p) => {
        this.$refs.darkOverlay.overlayOff();
      })

      App.addListener('appUrlOpen', ({ url }) => {
        try {
         // alert("appUrlOpen...." + url)
          const u = new URL(url)
           // Optional: only handle your domain
          //if (u.host !== 'rallyhood.com') return
          if (u.pathname.indexOf("users/passwords/reset_ras") > -1){
            router.push({
              path: "/resetpassword",
              query: { prt: u.searchParams.get('prt') },
            })
          } else {
            //alert("router:" + u.pathname + " " + Object.fromEntries(u.searchParams.entries()))
            router.push({
              path: u.pathname,
              query: Object.fromEntries(u.searchParams.entries()),
            })
        }
        } catch (e) {
           console.log('Bad deep link url:' + url + e)
        }
      });
  },
  mounted() {
    this.updateShowGlobalNav();
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear"
    }),
    ...mapActions("user", ["fetchUsersById", "reloadUserAfterRefresh"]),
    ...mapActions("rallies", ["toggleRallyInfo", "toggleMoveRallies"]),
    ...mapActions('rallies_v3', ['clearCurrentRally', 'fetchCurrentRallyData']),
    toggleSelected() {
      //this.isSelected = !this.isSelected;
      this.toggleMoveRallies()
    },
    backToDashboard() {
      this.$router.push("/rallies");
    },
    /*toggleOverlay() {
      console.log("this.$refs")
      console.log(this.$refs)
      this.$refs.darkOverlay.toggleOverlay();
    },*/
    async loadPageData() {
      try {
        if (userInfo() && userInfo().user_id) {
          this.reloadUserAfterRefresh()
          if (!this.usersById[parseInt(userInfo().user_id)]) {
            var rallyObjs = [];
            rallyObjs[this.rallyId] = { id: this.rallyId };
              this.fetchUsersById({
                userIds: [userInfo().user_id],
                loggedInUser: true
              });
          } else {
            loadUserFromStorage()
          }
        }
      } catch (e) {
        console.log("load page data error occured...")
        console.log(e);
      }
    },
    /**
     * App was backgrounded and is loading, need to get user info from persistent storage
     */
    async loadUserFromStorage(){
      try {
        const user = await userInfoPersistent();
        if (user) {
          localStorage.setItem('user', JSON.stringify(user));
        } else {
          router.push(`/login`);
        }
        if (Capacitor.getPlatform() != "web") {
          await store.dispatch('user/loadPushStuff', { user });
        }
      } catch (e) {
        console.log('error loading push stuff in login page', e);
      }
    },
    ensureCurrentRally(newRoute) {
      // This is not a rally route. Ensure that the `currentRally` is null.
      if ( ! newRoute.params.rallyId ) {
        this.clearCurrentRally()
      }

      // The rally specified in the route has changed.  Reload the header data.
      else if ( newRoute.params.rallyId != this.currentRally?.id ) {
        this.fetchCurrentRallyData({rallyId: newRoute.params.rallyId})
      }

      // Otherwise do nothing.
    },
    updateShowGlobalNav() {
      const errorUrl = ["error-404", "error-500"]
      const fullPath = this.$route?.fullPath ?? ""
      const isErrorPage = errorUrl.includes(fullPath.substring(fullPath.lastIndexOf("/") + 1, fullPath.length))
      const noUserPresent = ( !userInfo() || !userInfo().user_id )

      // ?preview=1 is set by QuickEventPreview's iframe so the page renders
      // bare (no top nav / breadcrumb) inside the preview modal frame.
      const isPreview = String(this.$route?.query?.preview ?? "") === "1"
      const isRoot = this.$route.path === "/"

      this.showGlobalNav = (!isErrorPage && !this.showMarketingSite && !this.isExemptPage && !isRoot && !noUserPresent && !isPreview)
    },
  },
  /*watch: {
        $route (to, from){
            // clear alert on location change
            this.clearAlert();
        }
    } */
};
</script>

<style lang="scss">
@import "../stylesheets/main.scss";
@media (max-width: 960px) {
  .app-arrows {
    color: black; /* Default color */
    cursor: pointer;
    transition: color 0.3s;
    left: 55px;
    top:60px;
    position: absolute;
  }
}

@media (min-width: 960px) {
  .app-arrows {
    display:none;
  }
}

.fa-arrows.selected {
  color: #1867c0; /* Selected color */
}

.move-rallies-label {
  font-family: 'Lato', sans-serif;
  font-size: 10px;
}

  .sh-normal-container {
    background: #e7edef;
    height: 100%;
  }
  .sh-normal-container.signup-route {
    background: #003e48;
  }
  .sh-updated-container {
    background: $rallyhood-darkest-blue;
    height: 100%;
  }
  @media (max-width: $mobile) {
    .sh-updated-container {
      padding: 16px 32px 32px;
      height: 100%;
    }
    .sh-normal-container {
      padding: 0px;
      height: 100%;
    }
  }
  @media (max-width: $small) {
    .sh-updated-container {
      padding: 20px 16px;
      height: 100%;
    }
    .sh-normal-container {
      padding: 0px;
      height: 100%;
    }
  }
</style>
